import { useGoogleMapsContext } from '../GoogleMapsContext/GoogleMapsContext.js';

const useGoogleMapsStaticMap = ({ lat , lon , params =''  })=>{
    const { googleMapsSettings: { apiKey  } ,  } = useGoogleMapsContext();
    if (!lat && !lon) {
        return undefined;
    }
    const mapImageUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lon}&zoom=13&size=640x200&scale=2&markers=anchor:28,48|icon:https://assets.grandvision.io/global/store2.png|scale:2%7C${lat},${lon}&mapType=roadmap&key=${apiKey}${params ? `&${params}` : ''}`;
    return mapImageUrl;
};

export { useGoogleMapsStaticMap as default };
//# sourceMappingURL=use-google-maps-static-map.js.map
